export default {
  props: {
    to: {
      type: String,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  computed: {
    isExternal() {
      return this.meta.is_link;
    },
    type() {
      if (this.isExternal) {
        return "a";
      }
      return "router-link";
    }
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: this.meta.link_url,
          target: "_blank",
          rel: "noopener"
        };
      }
      return {
        to: to
      };
    }
  }
};